import qs from 'query-string'

import getRequest from 'utils/getRequest'
import postRequest from 'utils/postRequest'

const path = '/api/admin/sensitive-sites'

// eslint-disable-next-line
export const requestGetSensitiveSites = ({
  // eslint-disable-next-line no-magic-numbers
  resultsPerPage = 12,
  // eslint-disable-next-line no-magic-numbers
  currentPage = 1,
  sortBy = 'siteCode',
  sortDirection = 'ASC',
  signal
}) => {
  const queryString = {
    resultsPerPage,
    currentPage,
    sortBy,
    sortDirection
  }
  const queryStringParsed = qs.stringify(queryString)
  return getRequest(`${path}?${queryStringParsed}`, signal)
}

export const requestApproveSensitiveSite = (siteHistoryId) => {
  return postRequest(`${path}/${siteHistoryId}/approve`)
}

export const requestRejectSensitiveSite = (siteHistoryId) => {
  return postRequest(`${path}/${siteHistoryId}/reject`)
}

